import { render, staticRenderFns } from "./KnowledgeCourses.vue?vue&type=template&id=12ec2d76&scoped=true&"
import script from "./KnowledgeCourses.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeCourses.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeCourses.vue?vue&type=style&index=0&id=12ec2d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec2d76",
  null
  
)

export default component.exports